import {Button, NonIdealState, TextArea} from "@blueprintjs/core";
import styled from "@emotion/styled";

interface ErrorBoundaryFallbackProps {
  error?: Error;
  componentStack?: string;
}

const ErrorContainer = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  width: "100vw",
  padding: "0",
  margin: "0"
});

/**
 * Error boundary fallback component shown when an unhandled error occurs
 * Matches the style of the existing ErrorBoundary component
 */
const ErrorBoundaryFallback = ({error, componentStack}: ErrorBoundaryFallbackProps) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorContainer data-testid="error-boundary-fallback">
      <NonIdealState icon="error" title="Uh Oh... An Error Occurred" description={error?.toString()}>
        <Button icon="refresh" intent="primary" onClick={handleRefresh}>
          Refresh Page
        </Button>
        {componentStack && (
          <details style={{border: "2px", maxWidth: "100%"}}>
            <TextArea
              style={{margin: "5px 0px", width: "800px"}}
              readOnly
              size="large"
              rows={15}
              value={componentStack}
            />
          </details>
        )}
      </NonIdealState>
    </ErrorContainer>
  );
};

export default ErrorBoundaryFallback;
